import { Lightning } from '@lightningjs/sdk';

export class Base<
  spec extends Lightning.Component.TemplateSpec,
  Type extends Lightning.Component.TypeConfig
> extends Lightning.Component<spec, Type> {}
